module.exports = "<app-page-contents [pageName]=\"pageName\"></app-page-contents>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/pages/page-manuscript-intro/page-manuscript-intro.component.html
// module id = ./src/app/components/pages/page-manuscript-intro/page-manuscript-intro.component.html
// module chunks = main